<script>
import {mapState} from "vuex";
import i18n from "@/i18n";
import { VueTelInput } from 'vue-tel-input';
import AddressEdit from "@/components/ClientPicker/AddressEdit.vue";
import countries_list from "@/assets/countries.json";
import {query} from "sinao-corejs";
import {getIndexesByContactEmail, validateEmail} from "@/mixins/methods";

export default {
  components: {
    AddressEdit,
    VueTelInput
  },
  props: {
  },
  data() {
    return {
      modalRefName: "ModalCreateOrganizationManualContent"
    };
  },
  computed: {
    ...mapState({
      appId: state => state.app.id,
      token: state => state.app.token,
      editableEstablishment: state => state.contacts.editableEstablishment,
      isThirdAccountGlobal: state => state.contacts.isThirdAccountGlobal
    }),
    organization: {
      get() {
        return this.$store.state.contacts.editableContact;
      },
      set(value) {
        this.$store.commit("editableContact", value);
      }
    },
    countries() {
      const _countries = [];
      Object.keys(countries_list).forEach((key) => {
        _countries.push({
          value: key,
          text: this.$t(countries_list[key])
        });
      });
      // Trier par nom traduit
      _countries.sort((a, b) => a.text.localeCompare(b.text));
      return _countries;
    },
    loadingContact: {
      get() {
        return this.$store.state.contacts.loadingContact;
      },
      set(value) {
        this.$store.commit("loadingContact", value);
      }
    }
  },
  mounted() {
    //this.$store.commit("renderGA", true);
  },
  methods: {
    async createOrganization() {
      // check email validity
      if (this.organization.email.length && !validateEmail(this.organization.email)) {
        this.$bvToast.toast(i18n.t('Email non valide'), {
          variant: "danger",
          solid: true
        });
        return;
      }
      // check SIREN validity
      if (this.organization.national_id?.length  && this.organization.national_id?.length !== 9 && this.organization.country === 'FR') {
        this.$bvToast.toast(i18n.t('SIREN non valide'), {
          variant: "danger",
          solid: true
        });
        return;
      }
      this.loadingContact = true;
      try {
        const created_organization = await query({
          operationId: "app.contacts.organizations.create",
          token: this.token,
          params: {
            'appId': this.appId,
            'expand[0]': 'establishments',
            'expand[1]': 'establishments.contacts',
          },
          data: {
            name: this.organization.name,
            billing_name: this.organization.billing_name,
            national_id: this.organization.national_id,
            country_iso2: this.organization.country,
            legal_form:	this.organization.legal_form,
            vat_id: this.organization.vat,
            establishments: [{
              email: this.organization.email,
              phone: this.organization.phone,
              place: {
                street_number: this.editableEstablishment.place.street_number || '',
                route: this.editableEstablishment.place.route || '',
                route2: this.editableEstablishment.place.route2 || '',
                postal_code: this.editableEstablishment.place.postal_code || '',
                locality: this.editableEstablishment.place.locality || '',
                country: this.editableEstablishment.place.country || ''
              }
            }]
          }
        });

        this.$bvToast.toast(i18n.t('Success_contact_add'), {
          variant: "success",
          solid: true
        });

        if (this.organization.email) {
          // has an email was provided, an establishment with an establishment contact have been created
          // get the establishment index and the EstablishmentContact index
          const { e_index, c_index } = getIndexesByContactEmail(created_organization.establishments, this.organization.email);
          if (e_index >= 0) {
            created_organization.establishment_id = created_organization.establishments[e_index].id;
          }
          if (c_index >= 0) {
            created_organization.establishment_contact_id = created_organization.establishments[e_index].contacts[c_index].id;
            created_organization.email = created_organization.establishments[e_index].contacts[c_index].email;
          }
        } else {
          // has no email => just set the first establishment id has it is a new contact and normally have one establishment
          created_organization.establishment_id = created_organization.establishments[0].id;
        }

        this.$store.commit( 'updateContactInfos', { data: created_organization, target: this.isThirdAccountGlobal === true ? 'thirdAccount' : 'contactInfos' });

        this.$store.commit("resetEditableContact");
        this.$store.commit("resetEditableEstablishment");
        // close parent dialog
        this.$nextTick(() => {
          this.$emit("close");
        });
      } catch (error) {
        console.error(error);
      }
      this.loadingContact = false;
    }
  }
};
</script>

<template>
    <b-container>
      <!-- organization information -->
      <b-row>
        <b-col cols="6" class="px-1">
          <b-form-input
              v-model="organization.name"
              size="sm"
              :placeholder="$t('Nom (raison sociale)') + ' *'"
          />
        </b-col>
        <b-col cols="6" class="px-1">
          <b-form-input
              v-model="organization.billing_name"
              size="sm"
              :placeholder="$t('Nom de facturation')"
          />
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="12" class="px-1">
          <b-form-input
              v-model="organization.email"
              size="sm"
              :placeholder="$t('Email')"
          /></b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="12" class="px-1">
          <vue-tel-input
              v-model="organization.phone"
              :input-options="{'placeholder': $t('Numéro de téléphone')}"
          />
        </b-col>
      </b-row>
      <b-row class="my-2">
        <b-col cols="12" class="px-1"><hr></b-col>
      </b-row>

      <!-- legal information -->
      <b-row class="">
        <b-col cols="12" class="px-1 m-0"><h6>{{ $t('Renseignements juridiques') }}</h6></b-col>
      </b-row>
      <b-row>
        <b-col cols="6" class="px-1">
          <b-form-select
              v-model="organization.country"
              :options="countries"
              size="sm"
          />
        </b-col>
        <b-col cols="6" class="px-1">
          <b-form-input
              v-model="organization.national_id"
              size="sm"
              :placeholder="organization.country === 'FR' ? $t('SIREN') : $t('national id')"
          />
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="6" class="px-1">
          <b-form-input
              v-model="organization.vat"
              size="sm"
              :placeholder="$t('vat number')"
          />
        </b-col>
        <b-col cols="6" class="px-1">
          <b-form-input
              v-model="organization.legal_form"
              size="sm"
              :placeholder="$t('forme juridique')"
          />
        </b-col>
      </b-row>

      <b-row class="my-2">
        <b-col cols="12" class="px-1"><hr></b-col>
      </b-row>

      <!-- organnization address -->
      <b-row class="">
        <b-col cols="12" class="px-1 m-0"><h6>{{ $t('Siege social') }}</h6></b-col>
      </b-row>
      <b-row>
        <AddressEdit map-id="createOrganization" />
      </b-row>
    </b-container>
</template>

<style src="../../../node_modules/vue-tel-input/dist/vue-tel-input.css"></style>
<style scoped lang="scss">

</style>